import styled from 'styled-components'
import { device } from '@/common/constants/device'
import { hideTextWithDots } from '@/components/common/BaseMixins'
import Text from '@/components/common/Text'
import BaseCopy from '@/components/common/BaseCopy'
import { CreativesContent } from '@/components/Creatives/CreativesStyled'

export const SearchContainer = styled.div`
  margin-bottom: 30px;

  @media ${device.tablet} {
    padding: 96px 20px 0;
  }
`

export const SearchContent = styled.div`
  position: relative;
`

export const SearchWrap = styled(CreativesContent)`
  display: grid;
  grid-template-columns: 1fr;

  &.visible-error {
    .creatives-list-placeholder {
      margin-bottom: 20px;
      min-height: 220px;

      @media ${device.tablet} {
        margin-bottom: 30px;
        min-height: 350px;
      }

      .placeholder-content {
        max-width: 500px;
      }
    }

    .creatives-list {
      margin-bottom: 50px;

      @media ${device.tablet} {
        margin-bottom: 65px;
      }
    }
  }

  overflow: hidden;
  overflow-x: auto;

  &.open {
    @media ${device.laptopM} {
      grid-template-columns: 1fr minmax(300px, 445px);
    }
  }
`

export const SearchList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 8px;

  @media ${device.tablet} {
    gap: 24px;
  }

  &.list,
  &.row {
    grid-template-columns: 1fr;

    ${SearchWrap} {
      grid-template-columns: 1fr;
    }
  }
`

export const SearchCopy = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  justify-self: flex-start;
  gap: 8px;

  ${Text} {
    flex-grow: 1;
    ${hideTextWithDots};
    display: none;

    @media ${device.tablet} {
      display: block;
    }

    span {
      max-width: 100%;
    }
  }
`

export const SearchCopyButton = styled(BaseCopy)`
  width: 24px;
  height: 24px;
  display: flex;

  @media ${device.tablet} {
    width: 20px;
    height: 20px;
  }

  button {
    width: 24px;
    height: 24px;

    @media ${device.tablet} {
      width: 20px;
      height: 20px;
    }
  }
`

export const SearchBlock = styled.div`
  &.open {
    display: grid;
    column-gap: 24px;
    max-width: 1664px;
    margin: 0 auto;

    @media ${device.tablet} {
      grid-template-columns: minmax(360px, 420px) 1fr;
    }
  }
`

export const SearchErrorText = styled.div`
  font-size: 14px;
  line-height: 1.2em;
  color: var(--tertiary);

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 1.2em;
  }
`
